import {ChangeDetectionStrategy, Component, HostBinding, input} from '@angular/core';
import {Checkbox} from "primeng/checkbox";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'homey-terms-conditions-checkbox',
  imports: [
    Checkbox,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './terms-conditions-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsConditionsCheckboxComponent {
  @HostBinding('class') class = 'flex gap-2 items-center mb-6';

  formControlInput = input.required<FormControl<boolean>>();
}
